// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"1330":"2ac81cf405432493c007","2580":"0e0d96829cba7f14cb07","2647":"49206c01754c32a7a526","5796":"9c4dd3d7a8264b833a31"}[chunkId] + ".css";
};